import React from 'react'

export default function Section({ header, children }) {
  return (
    <div className="dome-d-flex dome-flex-column dome-gap12">
      {header && <div className="dome-h4 dome-color-dark-grey dome-text-w500">{header}</div>}
      {children}
    </div>
  )
}
